export const blogPosts = [
  {
    slug: 'tetradka-ne-kassa',
    title: 'Тетрадка в 23:40 — это не учёт',
    excerpt: 'Вечером вы считаете наличные и Kaspi. Утром уже не помните, кому дали в долг. Sauda закрывает этот хаос за 5 минут.',
    category: 'Для владельца',
    readMinutes: 3,
    cover: 'night',
    body: [
      'Маленький магазин часто живёт без «настоящей» кассы: тетрадка, WhatsApp-сообщения кассиру, память. Это работает — пока не начинается путаница.',
      'Типичный вечер: закрыли точку, сели считать. Наличные одно, переводы другое, долг «Айгуль» где-то в заметках. На следующий день уже непонятно, сколько реально заработали.',
      'Sauda не требует бухгалтера и недели внедрения. Вы регистрируетесь, выбираете режим кассы и сразу пишете продажи. Вечером видна выручка по типам оплаты — без ручного сложения.',
      'Если пока лень заводить товары — включите «Быструю продажу»: только сумма и способ оплаты. Потом, когда захотите остатки и топ товаров, переключитесь на режим «По товарам».',
    ],
    takeaway: 'Начните с простого режима сегодня — учёт появится раньше, чем «когда-нибудь заведу Excel».',
  },
  {
    slug: 'dva-rezhima-kassy',
    title: 'Два режима кассы: по товарам и быстрая продажа',
    excerpt: 'Не всем нужен склад с первого дня. Sauda даёт выбор — и это снимает главное возражение: «мне лень добавлять товары».',
    category: 'Как работает',
    readMinutes: 4,
    cover: 'modes',
    body: [
      'В админке Sauda есть переключатель режима кассы. Он задаёт, как кассиры оформляют продажи.',
      'Режим «По товарам» — классическая касса: выбираете товар, количество или вес, скидку. Остатки списываются сами. Видно топ продаж и прибыль по позициям.',
      'Режим «Быстрая продажа» — для тех, кто хочет начать прямо сейчас: кассир вводит сумму чека и тип оплаты. Склад не трогается. Бонусы и қарыз работают как обычно.',
      'Переключить режим можно в любой момент. История продаж не ломается: у каждого чека сохраняется, в каком режиме он был сделан.',
      'Практичный путь: первую неделю работайте в быстрой продаже, привыкните к интерфейсу. Затем добавьте категории и товары — и включите полный режим.',
    ],
    takeaway: 'Не ждите идеального справочника товаров. Начните продавать сегодня — углубите учёт завтра.',
  },
  {
    slug: 'pochemu-maloму-biznesu',
    title: 'Почему маленькому магазину касса нужнее, чем большому',
    excerpt: 'У крупного ритейла есть бухгалтер и система. У вас — вечерняя тетрадка. Именно поэтому Sauda сделана простой.',
    category: 'Польза',
    readMinutes: 3,
    cover: 'shop',
    body: [
      'Большой магазин уже «закрыт» учётом. Маленький — нет. И именно маленький чаще теряет деньги на долгах, скидках «на глаз» и остатках «вроде ещё есть».',
      'Sauda заточена под этот сегмент: продукты, мини-маркеты, кофейни, фастфуд, точки у дома. Несколько кассиров, бонусы, қарыз, аналитика — без тяжёлой ERP.',
      'Кассир входит под своим паролем. В аналитике видно, кто сколько выручки сделал. Админ решает, можно ли кассиру менять товары и склад.',
      'Бонусная карта (5 цифр) и телефон помогают возвращать клиентов. Процент начисления вы сами задаёте в админке.',
    ],
    takeaway: 'Инструмент должен быть легче проблемы. Sauda легче тетрадки — и сильнее Excel «на коленке».',
  },
  {
    slug: 'start-za-5-minut',
    title: 'Старт за 5 минут: чеклист первой продажи',
    excerpt: 'Регистрация → режим кассы → первая оплата. Без внедрения и обучения персонала на неделю.',
    category: 'Старт',
    readMinutes: 2,
    cover: 'start',
    body: [
      '1. Зарегистрируйте магазин: название, e-mail, пароль.',
      '2. Зайдите в админку → «Режим кассы». Выберите «Быстрая продажа», если товары ещё не готовы, или «По товарам», если хотите склад сразу.',
      '3. Добавьте типы оплаты (наличные, Kaspi и т.д.), если нужно.',
      '4. Откройте кассу. В быстром режиме введите сумму и оплатите. В товарном — добавьте категории и пару позиций.',
      '5. По желанию включите бонусы: укажите процент начисления и заведите первого клиента.',
      'На планшете и телефоне интерфейс тот же. Ничего устанавливать не нужно — только браузер.',
    ],
    takeaway: 'Первая продажа в Sauda — это не проект. Это один вечер.',
  },
]

const kazakhBlogPosts = [
  {
    slug: 'tetradka-ne-kassa',
    title: 'Түнгі 23:40-тағы дәптер — бұл есеп емес',
    excerpt: 'Кешке қолма-қол мен Kaspi-ді санайсыз. Таңертең кімге қарыз бергеніңіз естен шығады. Sauda бұл ретсіздікті 5 минутта реттейді.',
    category: 'Иесіне',
    readMinutes: 3,
    cover: 'night',
    body: [
      'Шағын дүкен көбіне «нағыз» кассасыз жұмыс істейді: дәптер, кассирге WhatsApp-хабарламалар, есте сақтау. Шатасу басталғанша бұл әдіс жарайды.',
      'Кәдімгі кеш: нүктені жаптыңыз, санауға отырдыңыз. Қолма-қол бір бөлек, аударымдар бір бөлек, «Айгүлдің» қарызы жазбалардың арасында. Ертеңіне қанша тапқаныңыз түсініксіз.',
      'Sauda бухгалтерді де, бір апталық енгізуді де талап етпейді. Тіркелесіз, касса режимін таңдайсыз және бірден сатуды жүргізесіз. Кешке төлем түрлері бойынша түсім көрінеді — қолмен қосудың қажеті жоқ.',
      'Тауарларды енгізгіңіз келмесе — «Жылдам сатуды» қосыңыз: тек сома мен төлем тәсілі. Кейін қалдықтар мен тауарлар топ-10-ы керек болғанда «Тауарлар бойынша» режиміне ауысасыз.',
    ],
    takeaway: 'Бүгін қарапайым режимнен бастаңыз — есеп «бір күні Excel бастаймын» дегеннен ертерек пайда болады.',
  },
  {
    slug: 'dva-rezhima-kassy',
    title: 'Кассаның екі режимі: тауарлар бойынша және жылдам сату',
    excerpt: 'Барлығына бірінші күннен қойма керек емес. Sauda таңдау береді және «тауар қосуға ерінемін» деген басты күмәнді жояды.',
    category: 'Қалай жұмыс істейді',
    readMinutes: 4,
    cover: 'modes',
    body: [
      'Sauda админ панелінде касса режимін ауыстырғыш бар. Ол кассирлердің сатуды қалай рәсімдейтінін белгілейді.',
      '«Тауарлар бойынша» режимі — классикалық касса: тауарды, санын не салмағын, жеңілдікті таңдайсыз. Қалдықтар автоматты жазылады. Сату топтары мен позициялар бойынша пайда көрінеді.',
      '«Жылдам сату» режимі — дәл қазір бастағысы келетіндерге: кассир чек сомасы мен төлем түрін енгізеді. Қоймаға әсер етпейді. Бонустар мен қарыз әдеттегідей жұмыс істейді.',
      'Режимді кез келген уақытта ауыстыруға болады. Сату тарихы бұзылмайды: әр чекте оның қай режимде жасалғаны сақталады.',
      'Тәжірибелік жол: алғашқы аптада жылдам сатумен істеп, интерфейске үйреніңіз. Содан кейін санаттар мен тауарларды қосып, толық режимді іске қосыңыз.',
    ],
    takeaway: 'Тауарлардың мінсіз анықтамалығын күтпеңіз. Бүгін сата бастаңыз — есепті ертең тереңдетесіз.',
  },
  {
    slug: 'pochemu-maloму-biznesu',
    title: 'Неліктен шағын дүкенге касса үлкен дүкеннен де көбірек керек',
    excerpt: 'Ірі ритейлде бухгалтер мен жүйе бар. Сізде — кешкі дәптер. Сондықтан Sauda қарапайым етіп жасалған.',
    category: 'Пайдасы',
    readMinutes: 3,
    cover: 'shop',
    body: [
      'Үлкен дүкенде есеп әлдеқашан жолға қойылған. Шағын дүкенде — жоқ. Дәл осы дүкендер қарыздан, «көзбен» берілген жеңілдіктерден және «әлі бар сияқты» қалдықтардан жиі ақша жоғалтады.',
      'Sauda осы сегментке лайықталған: азық-түлік, мини-маркеттер, кофеханалар, фастфуд, үй жанындағы нүктелер. Бірнеше кассир, бонустар, қарыз, талдау — ауыр ERP-сіз.',
      'Кассир өз құпиясөзімен кіреді. Талдаудан кімнің қанша түсім жасағанын көресіз. Админ кассирдің тауар мен қойманы өзгерте алатынын шешеді.',
      'Бонустық карта (5 сан) мен телефон клиенттерді қайтаруға көмектеседі. Есептеу пайызын өзіңіз админ панелінде қоясыз.',
    ],
    takeaway: 'Құрал мәселенің өзінен жеңіл болуы керек. Sauda дәптерден жеңіл — және қолдан жасалған Excel-ден мықты.',
  },
  {
    slug: 'start-za-5-minut',
    title: '5 минутта бастау: алғашқы сатудың чек-парағы',
    excerpt: 'Тіркелу → касса режимі → алғашқы төлем. Енгізусіз және қызметкерлерді апталап оқытусыз.',
    category: 'Бастау',
    readMinutes: 2,
    cover: 'start',
    body: [
      '1. Дүкенді тіркеңіз: атауы, e-mail, құпиясөз.',
      '2. Админ панеліне өтіңіз → «Касса режимі». Тауарлар дайын болмаса «Жылдам сатуды», ал қойманы бірден қаласаңыз «Тауарлар бойынша» режимін таңдаңыз.',
      '3. Қажет болса төлем түрлерін қосыңыз (қолма-қол, Kaspi және т.б.).',
      '4. Кассаны ашыңыз. Жылдам режимде соманы енгізіп, төлеңіз. Тауарлық режимде санаттар мен бірнеше позиция қосыңыз.',
      '5. Қаласаңыз бонустарды қосыңыз: есептеу пайызын көрсетіп, алғашқы клиентті тіркеңіз.',
      'Планшет пен телефонда интерфейс бірдей. Ештеңе орнатудың қажеті жоқ — тек браузер керек.',
    ],
    takeaway: 'Sauda-дағы алғашқы сату — жоба емес. Бұл бір кеш.',
  },
]

export function getBlogPosts(locale = 'kk') {
  return locale === 'ru' ? blogPosts : kazakhBlogPosts
}

export function getPostBySlug(slug, locale = 'kk') {
  return getBlogPosts(locale).find((post) => post.slug === slug) || null
}
